import { Factory } from 'rosie';

Factory.define('ForgotPassword').attr('name', 'FORGOT_PASSWORD');

Factory.define('ForgotPasswordWithDefaults').extend('ForgotPassword');



// WEBPACK FOOTER //
// ./factories/location/forgot_password.js